import { render, staticRenderFns } from "./RegisteredTable.vue?vue&type=template&id=326501ef&"
import script from "./RegisteredTable.vue?vue&type=script&lang=js&"
export * from "./RegisteredTable.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports